import Aurelia from 'aurelia';
import { RouterConfiguration } from '@aurelia/router';
import { SVGAnalyzer } from '@aurelia/runtime-html';

import { AiohaService } from './services/aioha-service';
import { ApiClient } from './services/api-client';
import { MyApp } from './my-app';
import './styles/app.css';

Aurelia.register(
  RouterConfiguration.customize({ basePath: '/', useUrlFragmentHash: false, useHref: false }),
  SVGAnalyzer,
  AiohaService,
  ApiClient
)
  .app(MyApp)
  .start();
